import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseUrl, baseimgUrl } from "../Univ";
import { Link } from "react-router-dom";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

function Recommended() {

  const [items, setItems] = useState([]);
  const [itemsPerSlide, setItemsPerSlide] = useState(5);

    const token = localStorage.getItem("userGroup") === "Customer";

  useEffect(() => {

    // ⛔ Stop if not logged in
    if (!token) return;

    axios
      .get(baseUrl + "recommend/", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => setItems(res.data))
      .catch(() => {});

    const handleResize = () => {
      if (window.innerWidth < 576) setItemsPerSlide(1);
      else if (window.innerWidth < 768) setItemsPerSlide(2);
      else if (window.innerWidth < 992) setItemsPerSlide(3);
      else if (window.innerWidth < 1200) setItemsPerSlide(4);
      else setItemsPerSlide(5);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);

  }, [token]);

  // Hide if not logged in OR empty
  if (!token || !items.length) return null;

  const chunkProducts = (arr, size) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks;
  };

  const slides = chunkProducts(items, itemsPerSlide);

  return (
    <div className="mt-5">
      <h4>Recommended For You</h4>

      <Carousel
        showArrows
        showThumbs={false}
        showStatus={false}
        infiniteLoop
        swipeable
        emulateTouch
        autoPlay
      >
        {slides.map((group, index) => (
          <div
            key={index}
            className="d-flex justify-content-center gap-3 flex-wrap"
          >
            {group.map((p) => (
              <div
                key={p.id}
                className="product-slide"
                style={{ flex: "1 1 calc(20% - 10px)" }}
              >
                <div className="card h-100 shadow-sm">
                  <Link to={`/product/${p.id}`}>
                    <img
                      src={`${baseimgUrl}${p.images?.[0]?.image}`}
                      alt={p.name}
                      className="product-img"
                      style={{ width: "100%", objectFit: "contain" }}
                    />
                  </Link>

                  <div className="card-body text-center">
                    <h6 className="text-truncate">{p.name}</h6>
                    <p className="text-success fw-bold">
                      ₹{p.discount_price || p.price}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))}
      </Carousel>
    </div>
  );
}

export default Recommended;
